import { combineReducers } from 'redux';

import compensationPlans from './compensationPlans.reducer';
import subCompanies from './subCompanies.reducer';
import agencyApprovals from './subCompanyAgencyApprovals.reducer';
import assignedAe from './subCompanyAssignedAe.reducer';
import channels from './subCompanyChannels.reducer';
import checklists from './subCompanyChecklists.reducer';
import companyProfile from './subCompanyCompanyProfile.reducer';
import creditProvider from './subCompanyCreditProvider.reducer';
import licensedStates from './subCompanyLicensedStates.reducer';
import loanCount from './subCompanyLoanCount.reducer';
import nmlsLicenses from './subCompanyNmlsLicenses.reducer';
import nmlsLicensesStatus from './subCompanyNmlsLicensesStatus.reducer';
import pipelineAccess from './subCompanyPipelineAccess.reducer';
import signupConfig from './subCompanySignupConfig.reducer';
import tasks from './subCompanyTasks.reducer';
import tasksStatus from './subCompanyTasksStatus.reducer';
import taskUsers from './subCompanyTaskUsers.reducer';
import userCreditProviders from './subCompanyUserCreditProviders.reducer';
import tpoCertification from './tpoCertification.reducer';

const reducer = {
  subCompanies,
  subCompany: combineReducers({
    agencyApprovals,
    compensationPlans,
    licensedStates,
    nmlsLicenses,
    nmlsLicensesStatus,
    channels,
    assignedAe,
    companyProfile,
    signupConfig,
    pipelineAccess,
    tpoCertification,
    tasks,
    tasksStatus,
    taskUsers,
    checklists,
    loanCount,
    creditProvider,
    userCreditProviders,
  }),
};

export default reducer;
